import BaseObject from "@shared/BaseObject";

export type ToolEnginePrimitiveValue = string | number | boolean | null | undefined
export type ToolEngineDataShape = {
	[key: string]: ToolEngineDataValue
}
export type ToolEngineDataValue = ToolEnginePrimitiveValue | ToolEngineDataShape | ToolEngineDataValue[]

export class ToolEngineDataObject extends BaseObject {
	constructor(options: ToolEngineDataShape = {}) {
		super(options)
		this.applyOptions(options)
	}
}

export class BaseToolEngineConfig extends ToolEngineDataObject {
	title: string = ""
	instructions: string = ""
}

export class BaseEnginePayload extends ToolEngineDataObject {
}

export class BaseToolEngineState extends ToolEngineDataObject {
}

export class ToolEngineValidationResult extends ToolEngineDataObject {
	isValid: boolean = true
	errors: string[] = []
	warnings: string[] = []
}

export class BaseToolEngineItem extends ToolEngineDataObject {
	id: string = ""
	title: string = ""
	description: string = ""
}

export class BaseToolEngineGroup extends ToolEngineDataObject {
	id: string = ""
	title: string = ""
	description: string = ""
}

export class BaseToolGraphNode extends ToolEngineDataObject {
	id: string = ""
	type: string = ""
	data: ToolEngineDataShape = {}
}

export class BaseToolGraphEdge extends ToolEngineDataObject {
	id: string = ""
	type: string = ""
	sourceId: string = ""
	targetId: string = ""
	data: ToolEngineDataShape = {}
}

export class BaseToolResultSnapshot extends ToolEngineDataObject {
	summary?: BaseEnginePayload
	enginePayload?: BaseEnginePayload
}

export class BaseToolInstanceSnapshot extends ToolEngineDataObject {
	id: string = ""
	title: string = ""
	toolType: string = ""
	config: BaseToolEngineConfig = new BaseToolEngineConfig()
}

export class BaseToolDefinitionSnapshot extends ToolEngineDataObject {
	toolType: string = ""
	engine: string = ""
	participationMode: string = ""
	resultBehavior: string = ""
	configRenderer: string = ""
	workRenderer: string = ""
	resultRenderer: string = ""
}

export class ToolEngineOptions extends ToolEngineDataObject {
	syncGlobalScaleConfig?: boolean
}

type NonFunctionPropertyNames<TObject extends object> = {
	[TKey in keyof TObject]: TObject[TKey] extends Function ? never : TKey
}[keyof TObject]

type SerializableObjectData<TObject extends object> =
	ToolEngineDataShape & Partial<Pick<TObject, NonFunctionPropertyNames<TObject>>>

export type ToolEngineConfigData = SerializableObjectData<BaseToolEngineConfig>
export type EnginePayloadData = SerializableObjectData<BaseEnginePayload>
export type ToolEngineStateData = SerializableObjectData<BaseToolEngineState>
export type ToolEngineItemData = SerializableObjectData<BaseToolEngineItem>
export type ToolEngineGroupData = SerializableObjectData<BaseToolEngineGroup>
export type ToolGraphNodeData = SerializableObjectData<BaseToolGraphNode>
export type ToolGraphEdgeData = SerializableObjectData<BaseToolGraphEdge>
export type ToolResultSnapshotData = SerializableObjectData<BaseToolResultSnapshot> & {
	summary?: EnginePayloadData
	enginePayload?: EnginePayloadData
}
export type ToolInstanceSnapshotData = SerializableObjectData<BaseToolInstanceSnapshot> & {
	id?: string
	title?: string
	toolType?: string
	config?: ToolEngineConfigData
}
export type ToolDefinitionSnapshotData = SerializableObjectData<BaseToolDefinitionSnapshot> & {
	toolType?: string
	engine?: string
	participationMode?: string
	resultBehavior?: string
	configRenderer?: string
	workRenderer?: string
	resultRenderer?: string
	longitudinalClassId?: string
	longitudinalRendererId?: string
	blankPrintRenderer?: string
	resultPrintRenderer?: string
}

export interface FormElementModelInterface {
	id: string
	getAnswer(): ToolEngineDataValue
}

export interface FormModelInterface {
	title: string
	formElements: FormElementModelInterface[]
	syncScaleElementsWithGlobalScaleConfig(): void
	asJsonObject(): ToolEngineConfigData
	getScoreResultsOrRecalculate(): ToolEngineDataValue
}
